var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 45 45"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9519 35.212C12.0946 35.212 11.3831 34.9292 10.8173 34.3634C10.2503 33.7964 9.9668 33.0842 9.9668 32.227V27.8642H11.8038V32.227C11.8038 32.5331 11.9189 32.8007 12.1491 33.0297C12.3781 33.26 12.6457 33.3751 12.9519 33.3751H32.6993C33.0054 33.3751 33.273 33.26 33.502 33.0297C33.7323 32.8007 33.8474 32.5331 33.8474 32.227V27.8642H35.6843V32.227C35.6843 33.0842 35.4015 33.7964 34.8357 34.3634C34.2687 34.9292 33.5565 35.212 32.6993 35.212H12.9519ZM22.8256 28.2775L16.3043 21.8022L17.6361 20.4704L21.9071 24.7413V8.85156H23.7441V24.7413L28.015 20.4704L29.3468 21.8022L22.8256 28.2775Z",
    fill: "currentColor"
  })));
};

export default __webpack_public_path__ + "static/media/download.b9c52e1d.svg";
export { SvgComponent as ReactComponent };